export enum EnergyCusomerStatusEnum {
  'Ja',
  'Nej (Ønsker ikke skifte)',
  'Nej (Ønsker skifte)'
}
